import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Card, CardHeader, Flex, Heading, spaceMixin } from '@zillow/constellation';
import styled from 'styled-components';
import Tag from './Tag';
import TagType from '../../../../../../constants/tagType';

const StyledCard = styled(Card)`
  :not(:last-child) {
    margin-bottom: ${spaceMixin('lg')};
  }
`;

const StyledCardHeader = styled(CardHeader)`
  display: flex;
  align-items: center;
  padding-bottom: ${(props) => spaceMixin(props.isMain ? 'lg' : 'xl')};
`;

function DetailSection({ id, children, heading, forwardedRef, isMain = false, tagType = null }) {
  return (
    <StyledCard id={id} cardType="secondary" padding="sm" mediaQuery={{ lg: { padding: 'lg' } }} ref={forwardedRef}>
      <StyledCardHeader as="div" marginBottom="xl" isMain={isMain}>
        <Flex
          display="flex"
          flexWrap="wrap"
          justifyContent={tagType === TagType.incomeVerifiedByFinicity && 'space-between'}
          style={{ width: '100%' }}
        >
          <Heading id="detail-section-heading" level={isMain ? 3 : 4} as="h2" marginRight="lg">
            {heading}
          </Heading>
          <Tag tagType={tagType} />
        </Flex>
      </StyledCardHeader>
      {children}
    </StyledCard>
  );
}

DetailSection.propTypes = {
  id: PropTypes.string,
  heading: PropTypes.string.isRequired,
  forwardedRef: PropTypes.any,
  children: PropTypes.node.isRequired,
  isMain: PropTypes.bool,
  tagType: PropTypes.string,
};

export default forwardRef(function ForwardedRef(props, ref) {
  return <DetailSection {...props} forwardedRef={ref} />;
});
